export type BidStatusCardRPProps = {
	bidTitle: () => string;
	hasBid: boolean;
	hasFinished: boolean;
	isOwnBid: boolean;
	priceCurrentBid: number;
	priceNextBid?: number;
};

export const enum AuctionStatusRP {
	ACTIVE = 'active',
	CURRENT = 'current',
	FINISHED = 'finished',
	OWN = 'own',
	STARTING = 'starting',
	WINNING = 'winning',
	WON = 'won'
}
